import React, { useEffect, useRef, useState } from "react";
import "../../styles/components/browse_photographers_page/UniversalSearchBar.css";

async function geocodeLocation(query, signal) {
  const MAPBOX_TOKEN = "pk.eyJ1Ijoicmh5c2dpIiwiYSI6ImNtNXN2djRwcjBueWsya3NlZ2IzeHA4NGcifQ.XNbZeepgUkZ1NRo-lBBoaA";
  const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?access_token=${MAPBOX_TOKEN}&limit=4`;

  try {
    const response = await fetch(url, { signal });
    if (!response.ok) throw new Error('Location search failed');
    const data = await response.json();

    if (data.features) {
      return data.features.map((feature) => ({
        type: "location",
        label: feature.place_name,
        data: feature,
      }));
    }
  } catch (error) {
    if (!signal.aborted) console.error("Mapbox geocoding error:", error);
  }

  return [];
}

export default function UniversalSearchBar({ value, onChange, onSelect }) {
  const [suggestions, setSuggestions] = useState([]);
  const [query, setQuery] = useState(null);
  const containerRef = useRef(null);

  useEffect(() => {
    setSuggestions([]);
    if (query !== null && query !== value) { setQuery(null); return; }
    if (query === null || !query.trim()) return;
    const controller = new AbortController();
    const timeout = setTimeout(async () => {
      const results = await geocodeLocation(query.trim(), controller.signal);
      if (!controller.signal.aborted) setSuggestions(results);
    }, 300);
    return () => { clearTimeout(timeout); controller.abort(); };
  }, [query, value]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setSuggestions([]);
        setQuery(null);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleChange = (event) => {
    const newValue = event.target.value;
    onChange(newValue);
    setQuery(newValue);
  };

  const handleSelect = (suggestion) => {
    setSuggestions([]);
    setQuery(null);
    onSelect(suggestion);
  };

  return (
    <div className="universal-search-container" ref={containerRef}>
      <span className="universal-search-icon" aria-hidden="true">⌕</span>
      <span className="universal-search-label">Where?</span>
      <input
        className="universal-search-input"
        type="search"
        placeholder="Where is the shoot?"
        value={value}
        onChange={handleChange}
        aria-label="Search by shoot location"
        aria-expanded={suggestions.length > 0}
      />

      {suggestions.length > 0 && (
        <div className="universal-search-suggestions">
          <div className="universal-search-group">
            <div className="universal-search-group__label">Places</div>
            {suggestions.map((suggestion, index) => (
              <button
                type="button"
                className="universal-search-result"
                key={suggestion.data?.id || index}
                onMouseDown={(event) => {
                  event.preventDefault();
                }}
                onClick={() => handleSelect(suggestion)}
              >
                <span className="universal-search-result__icon" aria-hidden="true">⌖</span>
                <span className="universal-search-result__copy">
                  <strong>{suggestion.label}</strong>
                  <span>Location</span>
                </span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
